import { ColorTypes } from '@genial/design-tokens';

interface IProductDistributionItem {
  color: ColorTypes.Option;
  fullName: string;
}

export const productDistributionMap: {
  [key: string]: IProductDistributionItem;
} = {
  RENDA_VARIAVEL: {
    color: 'product.rendavariavel',
    fullName: 'Renda Variável',
  },
  FUNDO: {
    color: 'product.fundos',
    fullName: 'Fundos',
  },
  PREVIDENCIA: {
    color: 'product.previdencia',
    fullName: 'Previdência',
  },
  RENDA_FIXA: {
    color: 'product.rf',
    fullName: 'Renda Fixa',
  },
  TESOURO_DIRETO: {
    color: 'product.tesouro',
    fullName: 'Tesouro Direto',
  },
  CLUBES: {
    color: 'product.clubes',
    fullName: 'Clubes',
  },
  OPERACAO_ESTRUTURADA: {
    color: 'product.estruturados',
    fullName: 'Operações Estruturadas',
  },
};

export const getProductDistributionMap = (key?: string | null): IProductDistributionItem => {
  if (!key || !productDistributionMap[key]) {
    return { color: 'neutral.light', fullName: '' };
  }
  return productDistributionMap[key];
};

export const screenName = 'ManagementAnalysis';
